import { isDevMode } from '@angular/core';
import { TranslocoHttpLoaderService } from '@app/translation/domain/transloco-htttp-loader.service';
import { TranslocoOptions } from '@jsverse/transloco';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeId from '@angular/common/locales/id';
import localeJa from '@angular/common/locales/ja';
import localeKo from '@angular/common/locales/ko';
import localePt from '@angular/common/locales/pt';
import localeTh from '@angular/common/locales/th';
import localeVi from '@angular/common/locales/vi';
import localeZhHans from '@angular/common/locales/zh-Hans';
import localeZhHant from '@angular/common/locales/zh-Hant';

// Only en is registered, I need to register es and pt too so the localized pipes work
registerLocaleData(localeEs, 'es');
registerLocaleData(localeId, 'id');
registerLocaleData(localeJa, 'ja');
registerLocaleData(localeKo, 'ko');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeTh, 'th');
registerLocaleData(localeVi, 'vi');
registerLocaleData(localeZhHans, 'zh-hans');
registerLocaleData(localeZhHant, 'zh-hant');

export const translocoConfig: TranslocoOptions = {
  config: {
    availableLangs: [
      {
        id: 'en',
        label: 'English',
      },
      {
        id: 'es',
        label: 'Spanish',
      },
      {
        id: 'id',
        label: 'Indonesian',
      },
      {
        id: 'ja',
        label: 'Japanese',
      },
      {
        id: 'ko',
        label: 'Korean',
      },
      {
        id: 'pt',
        label: 'Portuguese',
      },
      {
        id: 'th',
        label: 'Thai',
      },
      {
        id: 'vi',
        label: 'Vietnamese',
      },
      {
        id: 'zh-hans',
        label: 'Simplified Chinese',
      },
      {
        id: 'zh-hant',
        label: 'Traditional Chinese',
      },
    ],
    defaultLang: 'en',
    reRenderOnLangChange: true,
    prodMode: !isDevMode(),
  },
  loader: TranslocoHttpLoaderService,
};
